import { ContainerModule } from "inversify";
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import FillInQuestionComponent from "./fill-in-question-component.vue";
import FillInQuestionSolutionComponent from "./fill-in-question-solution-component.vue";
import { FillInQuestionAnswerProtobufSerializer } from "./fill-in-question-answer-protobuf-serializer";

export const fillInQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(FillInQuestionComponent)
    .whenTargetNamed("fill-in");

  bind<Api.QuestionComponentPlugin>(Api.QuestionSolutionPluginSymbol)
    .toConstantValue(FillInQuestionSolutionComponent)
    .whenTargetNamed("fill-in");

    bind(SerializationApi.StateSerializationPluginSymbol).to(FillInQuestionAnswerProtobufSerializer)
});
